import { useSplunkTheme } from '@splunk/themes';
import { headerHeightInterpolationTree } from './themeInterpolation';

export const useGetFlyoutHeaderHeight = () => {
    // when no context provider is used the default theme is Prisma/Dark/compact
    const { density, family } = useSplunkTheme();
    return headerHeightInterpolationTree[family][density];
};
